var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3674 35C7.77566 35 0 27.165 0 17.5C0 7.83502 7.77566 0 17.3674 0C26.9592 0 34.7348 7.83502 34.7348 17.5C34.7243 27.1606 26.9548 34.9894 17.3674 35ZM17.3674 3.5C9.73513 3.50195 3.53333 9.70701 3.47737 17.3974C3.42141 25.0877 9.53225 31.3837 17.1637 31.4984C24.7951 31.6132 31.0896 25.5036 31.2613 17.815V20.9353V17.5C31.2527 9.77161 25.0372 3.50868 17.3674 3.5ZM19.8857 26.075L11.2888 17.4125L19.8857 8.75L22.3414 11.2245L16.2003 17.4125L22.3397 23.6005L19.8874 26.075H19.8857Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircle);
export default __webpack_public_path__ + "static/media/arrow_circle.3c3d025fc9af9f5932071f7a79277b34.svg";
export { ForwardRef as ReactComponent };